import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { PageLoading } from "./States";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <PageLoading label="Checking your session…" />;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  return children;
}

export function AdminRoute({ children }) {
  const { user, loading, isAdmin } = useAuth();
  if (loading) return <PageLoading label="Checking your session…" />;
  if (!user) return <Navigate to="/login" replace />;
  if (!isAdmin) return <Navigate to="/dashboard" replace />;
  return children;
}

export function SupportRoute({ children }) {
  const { user, loading, isSupport } = useAuth();
  if (loading) return <PageLoading label="Checking your session…" />;
  if (!user) return <Navigate to="/login" replace />;
  if (!isSupport) return <Navigate to="/dashboard" replace />;
  return children;
}
